import { trpc } from "../trpc";

interface Input {
  folderId?: string;
}

export function useBulkChangeCanvasOwner(input?: Input) {
  const { folderId } = input || {};
  const utils = trpc.useUtils();

  const { mutateAsync, isPending, error, isSuccess, isError } =
    trpc.canvas.bulkChangeOwner.useMutation({
      onSettled: () => {
        utils.canvas.search.invalidate();
        utils.permission.checkPermissions.invalidate();
        if (folderId) {
          utils.asset.getHydratedFolderAssets.invalidate({
            folderId,
          });
        }
      },
    });

  return {
    bulkChangeCanvasOwner: mutateAsync,
    error,
    isError,
    isLoading: isPending,
    isPending,
    isSuccess,
  };
}
